import { t, jt } from 'ttag';
import { Link } from 'react-router-dom';
import PageTitle from 'components/PageTitle/index.js';
import PageDescription from 'components/PageDescription/index.js';
import IllustrationFaq from 'static/illustrations/faq.svg';
import './index.scss';

const NotFound = ({ message }) => {
    const HomeLink = (
        <Link key='home-link' to='/' className='link link-underlined' replace>
            {t`(NOT_FOUND)_HOME_LINK_LABEL`}
        </Link>
    );

    return (
        <main id='not-found'>
            <PageTitle label={t`(VIEW_TITLE)_NOT_FOUND`} />
            <IllustrationFaq />
            <PageDescription label={message || jt`(NOT_FOUND)_BODY${HomeLink}`} />
        </main>
    );
};

export default NotFound;
